import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  expiresAtUtc: null,
  username: null,
  fullName: null,
  designation: null,
  mustChangePassword: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    credentialsSet: (state, action) => {
      const { token, expiresAtUtc, username, fullName, designation, mustChangePassword } =
        action.payload;
      state.token = token;
      state.expiresAtUtc = expiresAtUtc;
      state.username = username;
      state.fullName = fullName;
      state.designation = designation || null;
      state.mustChangePassword = Boolean(mustChangePassword);
    },
    // The server clears MustChangePassword on a successful change; mirror it
    // here (auth is the persisted slice) so the temporary-password prompt goes
    // away at once instead of at the next sign-in.
    passwordChanged: (state) => {
      state.mustChangePassword = false;
    },
    loggedOut: () => initialState,
  },
});

export const { credentialsSet, passwordChanged, loggedOut } = authSlice.actions;
export default authSlice.reducer;

export const selectIsAuthenticated = (state) => Boolean(state.auth.token);
export const selectAuth = (state) => state.auth;
